module.exports = __webpack_public_path__ + "img/top_title_lankao.9de8abe6.jpg";